// export  function changLang(lang) {
//   this.lang = localStorage.setItem("language",
//  lang)

// }

export const languages = {
  hu: {
    banner_web_1: "img/banner/bannerHU-hu.jpg",
    banner_web_2: "img/banner/bannerHU-hu.jpg",
    // banner_web_3: "img/banner/3-1920x200-V.jpg",
    banner_phone_1: "img/banner/1-500x200-hu.jpg",
    banner_phone_2: "img/banner/1-500x200-hu.jpg",
    Slide_docTiep: "Đọc tiếp",
      imgBieuTrung:"img/footer/Bieu_Trung_BCY.png",
    logoNHNN:"img/footer/NHNN_trans.png",
        img_bct:"img/footer/bct.png",

    // // #top     menu dung chung
    header_text_gioiThieu: "Giới thiệu",
    main_images_b1: "img/8cuc/Thietbithietyeu-hu.jpg",
    main_images_b2: "img/8cuc/nguoidung-hu.jpg",
    main_images_b3: "img/8cuc/hethongphanphoi-hu.jpg",
    main_images_congTy: "img/8cuc/congty-hu.jpg",
    footer_text_row_footer1_nganHang: " VIETNÁMI ÁLLAMI BANK ",
    footer_text_row_footer1_giayPhep:
      " 41/GP-NHNN fizetési közvetítői engedély ",
    footer_text_row_footer1_giayPhepXuatNhapKhau:
      " 2. Polgári kriptográfiai termékek exportjára és importjára vonatkozó engedély ",
    footer_text_row_footer1_giayPhepKinhDoanh:
      " 1. Polgári kriptográfiai termékek és szolgáltatások kereskedelmére vonatkozó engedély ",
    footer_text_row_footer1_downloadQrVietnam: " QR Vietnam alkalmazás letöltése ",
    footer_text_row_footer1_downloadViViMass: " Vimass Wallet alkalmazás letöltése ",
    footer_text_row_footer1_downloadVCard: " VCard alkalmazás letöltése ",
    footer_text_row_footer1_xemThem: "Továbbiak :",
    footer_text_tenCty: "VIMASS RÉSZVÉNYTÁRSASÁG - MAGYARORSZÁG",
    footer_text_hoiSoHaNoi:
      " Székhely: Budapest, Hungary ...",
    footer_text_hoiSoHaNoiQRVN:
      " Székhely: 506. szoba, 5. emelet, Golden Palm Épület, Le Van Luong utca 21., Nhan Chinh, Thanh Xuan, Hanoi - 0243.9416205 iroda",
    footer_text_ctyTrucThuoc: "A ViMASS LEÁNYVÁLLALATAI",
    footer_text_ctyQRVN: "QR VIETNAM RÉSZVÉNYTÁRSASÁG",
    footer_text_theDaNang: "Többfunkciós kártya",
    footer_text_diemThanhToan: "Üzleti pont",
    footer_text_ungDung: "Alkalmazás",
    footer_text_thietBi: "Berendezés",
    footer_text_phanMem: "Szoftver",
    footer_text_dichVu: "Szolgáltatás",
    footer_text_khachHang: "Ügyfél",
    footer_text_cty: "Cég",
    footer_text_chuongTrinhTaiTro: "Szponzorációs program",
    footer_text_giaiPhapChuyenDoiSo: "Digitális transzformációs megoldás",
    footer_text_diemGiaoDich: "Tranzakciós pont",
    footer_text_diemRaVao: "Azonosítási pont",
    footer_text_daudocbantay: "Kézolvasó",
    footer_text_banHangBangVietQR: "Értékesítés a VietQR-rel",
    item_footer_0: "Intelligens fizetés",
    item_footer_1: "Intelligens egészségügy",
    item_footer_2: "Közszolgáltatások, Mezőgazdaság",
    item_footer_3: "Intelligens közlekedés",
    item_footer_4: "Intelligens oktatás",
    item_footer_5: "Közösségi szponzorációs program",
    item_footer_6: "Szolgáltatások, Berendezések, API, VCloud",
    item_footer_7: "Cég, Partner",
    item_footer_9: "Intelligens mezőgazdaság",
    item_footer_10: "Intelligens közszolgáltatások",
        header_text_ungDung_viVimass : "Vimass tudja",
        footer_text_theVimass: "Vimass kártya",
footer_text_LienHe: "Kapcsolat",
header_text_QRtaikhoantrunggian: "Közbenső fiók QR-kódja",
thietbi: "Eszköz",
header_text_qrThanhToan: "Fizetés",
header_text_viDienTu: "Vimass pénztárca alkalmazás",
header_text_ungDung_theDaNang: "Vimass kártya",
header_text_lienHe: "Kapcsolatfelvétel",
  },
  vi: {
      header_text_viDienTu: "Ứng dụng Ví Vimass",
     header_text_QRtaikhoantrunggian: "QR tài khoản trung gian",
    thietbi: "Thiết bị",
    //bannner
    banner_web_1: "img/banner/bannerHU-v.jpg",
    banner_web_2: "img/banner/bannerHU-v.jpg",
    // banner_web_3: "img/banner/3-1920x200-V.jpg",
    banner_phone_1: "img/banner/1-500x200-v.jpg",
    banner_phone_2: "img/banner/1-500x200-v.jpg",
    imgBieuTrung:"img/footer/Bieu_Trung_BCY.png",
    logoNHNN:"img/footer/NHNN_trans.png",
    img_bct:"img/footer/bct.png",

    Slide_docTiep: "Đọc tiếp",
    // // #top     menu dung chung
    header_text_gioiThieu: "Giới thiệu",
       main_images_b1: "img/8cuc/Thietbithietyeu-v.jpg",
    main_images_b2: "img/8cuc/nguoidung-v.jpg",
    main_images_b3: "img/8cuc/hethongphanphoi-vjpg.jpg",
    main_images_congTy: "img/8cuc/congty-v.jpg",
    footer_text_row_footer1_nganHang: " NGÂN HÀNG NHÀ NƯỚC VIỆT NAM",
    footer_text_row_footer1_giayPhep:
      " Giấy phép trung gian thanh toán 41/GP-NHNN",
    footer_text_row_footer1_giayPhepXuatNhapKhau:
      "2. Giấy phép xuất khẩu, nhập khẩu sản phẩm mật mã dân sự",
    footer_text_row_footer1_giayPhepKinhDoanh:
      " 1. Giấy phép kinh doanh sản phẩm, dịch vụ mật mã dân sự",
    footer_text_row_footer1_downloadQrVietnam: " Tải ứng dụng QR Việt Nam",
    footer_text_row_footer1_downloadViViMass: " Tải ứng dụng Ví Vimass",
    footer_text_row_footer1_downloadVCard: " Tải ứng dụng VCard",
    footer_text_row_footer1_xemThem: "Xem thêm :",
    footer_text_tenCty: " CÔNG TY CỔ PHẦN VIMASS - HUNGARY",
    footer_text_hoiSoHaNoi:
      " Hội sở: Budapest, Hungary",
    footer_text_hoiSoHaNoiQRVN:
      " Hội sở: Phòng 506, Tầng 5, Tòa nhà The Golden Palm, 21 Lê Văn Lương, P.Thanh Xuân, Hà Nội - ĐT 0243.9416205",
    footer_text_cnHCM:
      "CN Hồ Chí Minh: Tầng 4, 121 Hoàng Hoa Thám, Phường 6, Q.Bình Thạnh - ĐT 0986609344",
    footer_text_ctyTrucThuoc: "CÔNG TY TRỰC THUỘC ViMASS",
    footer_text_ctyQRVN: "CÔNG TY CỔ PHẦN QR VIỆT NAM",
    footer_text_theDaNang: "Thẻ đa năng",
    footer_text_diemThanhToan: "Điểm kinh doanh",
    footer_text_ungDung: "Ứng dụng",
    footer_text_thietBi: "Thiết bị",
    footer_text_phanMem: "Phần mềm",
    footer_text_dichVu: "Dịch vụ",
    footer_text_khachHang: "Khách hàng",
    footer_text_cty: "Công ty",
    footer_text_chuongTrinhTaiTro: "Chương trình tài trợ",
    footer_text_giaiPhapChuyenDoiSo: "Giải pháp chuyển đổi số",
    footer_text_diemGiaoDich: "Điểm giao dịch",
    footer_text_diemRaVao: "Điểm định danh",
    footer_text_daudocbantay: "Đầu đọc bàn tay",
    footer_text_theVimass: "Thẻ Vimass",
    footer_text_LienHe: "Liên hệ",
    footer_text_banHangBangVietQR: "Bán hàng bằng VietQR",
    item_footer_0: "Thanh toán thông minh",
    item_footer_1: "Y tế thông minh",
    item_footer_2: "Dịch vụ công, Nông nghiệp",
    item_footer_3: "Giao thông thông minh",
    item_footer_4: "Giáo dục thông minh",
    item_footer_5: "Chương trình tài trợ xã",
    item_footer_6: "Dịch vụ, Thiết bị, API, VCloud",
    item_footer_7: "Công ty, Đối tác",
    item_footer_9: "Nông nghiệp thông minh",
    item_footer_10: "Dịch vụ công thông minh",
header_text_ungDung_viVimass : "Ví Vimass",
 header_text_qrThanhToan: "Thanh toán",
     header_text_ungDung_theDaNang: "Thẻ Vimass",
        header_text_lienHe: "Liên hệ",
  },

  en: {
    header_text_lienHe: "Contact",
    header_text_ungDung_theDaNang: "Vimass Card",
    header_text_viDienTu: "Vimass Wallet Application",
    header_text_qrThanhToan: "Payment",
 thietbi: "Device",
    //banner
    banner_web_1: "img/banner/1-1920x200-E.jpg",
    banner_web_2: "img/banner/2-1920x200-E.jpg",
    banner_web_3: "img/banner/3-1920x200-E.jpg",
    banner_phone_1: "img/banner/1-500x200-E.jpg",
    banner_phone_2: "img/banner/2-500x200-E.jpg",
    img_tangluong: "https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1759370459524AiOGF",

  imgBieuTrung:"img/footer/Bieu_Trung_BCY.png",
    logoNHNN:"img/footer/NHNN_trans.png",
    img_bct:"img/footer/bct.png",
    Slide_docTiep: "Read more",
      main_images_b1: "img/8cuc/Thietbithietyeu-e.jpg",
    main_images_b2: "img/8cuc/nguoidung-e.jpg",
    main_images_b3: "img/8cuc/hethongphanphoi-e.jpg",
    main_images_congTy: "img/8cuc/congty-e.jpg",
footer_text_theVimass: "Vimass Card",
footer_text_LienHe: "Contact",
    footer_text_tenCty: "VIMASS JOINT STOCK COMPANY - HUNGARY",

    footer_text_hoiSoHaNoi:
      "  Head office: Budapest, Hungary ",
    footer_text_hoiSoHaNoiQRVN:
      "  Head office: Room 506, 5th floor, Golden Palm Building, 21 Le Van Luong Street, Nhan Chinh, Thanh Xuan, Hanoi - Office 0243.9416205",

    footer_text_row_footer1_nganHang: " STATE BANK OF VIETNAM ",

    footer_text_row_footer1_giayPhep:
      " Payment intermediary license 41/GP-NHNN ",

    footer_text_row_footer1_giayPhepXuatNhapKhau:
      " 2. License to export and import civil cryptographic products ",

    footer_text_row_footer1_giayPhepKinhDoanh:
      " 1. License to trade civil cryptographic products and services ",

    footer_text_row_footer1_downloadQrVietnam: " Download QR Vietnam application ",

    footer_text_row_footer1_downloadViViMass: " Download Vimass Wallet application ",

    footer_text_row_footer1_downloadVCard: " Download VCard application ",

    footer_text_row_footer1_xemThem: "See more :",

    footer_text_ctyTrucThuoc: "COMPANY SUBSIDIARIES OF ViMASS",

    footer_text_ctyQRVN: "QR VIETNAM JOINT STOCK COMPANY",

    footer_text_theDaNang: "Multi-function card",

    footer_text_diemThanhToan: "Business point",

    footer_text_ungDung: "Application",

    footer_text_thietBi: "Equipment",

    footer_text_phanMem: "Software",

    footer_text_dichVu: "Service",

    footer_text_khachHang: "Customer",

    footer_text_cty: "Company",

    footer_text_chuongTrinhTaiTro: "Sponsorship program",

    footer_text_giaiPhapChuyenDoiSo: "Digital transformation solution",

    footer_text_diemGiaoDich: "Transaction Point",

    footer_text_diemRaVao: "Identification Point",
    footer_text_daudocbantay: "Hand Reader",
    footer_text_banHangBangVietQR: "Selling with VietQR",

    item_footer_0: "Smart Payment",
    item_footer_1: "Smart Healthcare",
    item_footer_2: "Public Services, Agriculture",
    item_footer_3: "Smart Transportation",
    item_footer_4: "Smart Education",
    item_footer_5: "Commune Sponsorship Program",
    item_footer_6: "Services, Equipment, API, VCloud",
    item_footer_7: "Company, Partner",
    item_footer_9: "Smart Agriculture",
    item_footer_10: "Smart Public Services",
    header_text_ungDung_viVimass : "Vimass",
header_text_QRtaikhoantrunggian: "Intermediate account QR code",
  },

};
